/**
 * @private
 */
export const keyMirrorList = (keys: string[] = []) => {
  const obj: { [key: string]: string } = {}
  const uniqueKeys = new Set(keys)

  for (const key of uniqueKeys) {
    obj[key] = key
  }

  return obj
}
